import { Provider } from '@angular/core';

import {
  CheckFilesService,
  CheckHealthUrlsService,
  CheckInternetConnectionService,
  CheckWebSocketService,
} from './services/troubleshooting';

import {
  TROUBLESHOOTING,
  TROUBLESHOOTING_CONFIG,
  TroubleshootingConfig,
} from './troubleshooting.token';

export function provideTroubleshooting(config: TroubleshootingConfig): Provider[] {
  return [
    {
      provide: TROUBLESHOOTING,
      multi: true,
      useClass: CheckInternetConnectionService,
    },
    {
      provide: TROUBLESHOOTING,
      multi: true,
      useClass: CheckWebSocketService,
    },
    {
      provide: TROUBLESHOOTING,
      multi: true,
      useClass: CheckHealthUrlsService,
    },
    {
      provide: TROUBLESHOOTING,
      multi: true,
      useClass: CheckFilesService,
    },
    {
      provide: TROUBLESHOOTING_CONFIG,
      useValue: config,
    },
  ];
}
